import {
  aThreatIntelSourcePage,
  mockThreatIntelSourcesOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockThreatIntelSourcesOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          threatIntelSources: aThreatIntelSourcePage(),
          threatIntelItemCount: aThreatIntelSourcePage().total,
          threatIntelItemLimit: 1,
        },
      });
    }
  ),
];
